import { QuestionNode, IInputNode } from '../../../actionCard'

const MAIL_REGEX = /^[A-Za-z0-9_]+[A-Za-z0-9_%-.+]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/
const MAIL_MAX_LENGTH = 320

export class EmailQuestionNode extends QuestionNode implements IInputNode<string | undefined> {
  public override setValue(value?: string): void {
    if (value && MAIL_REGEX.test(value) && value.length < MAIL_MAX_LENGTH) {
      super.setValue(value)
    } else {
      super.setValue()
    }
  }

  public override setStringValue(value?: string): void {
    this.setValue(value)
  }
}
